import createLucideIcon from '../createLucideIcon';

const Disc = createLucideIcon('DiscIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '3', key: '1v7zrd' }],
]);

export default Disc;
